import request from "@/service";

/* 查询期刊期次信息列表 */
export function periodicalPeriodList(data) {
  return request({
    url: `/resource/periodical/period/page`,
    method: "get",
    params: data
  });
}
/* 期刊期次列表根据期刊id */
export function periodYearList(id) {
  return request({
    url: `/resource/periodical/period/list/${id}`,
    method: "get"
  });
}

/* 期刊期次列表根据期刊id 年份*/
export function periodList(id, year) {
  return request({
    url: `/resource/periodical/period/list/${id}/${year}`,
    method: "get"
  });
}

/* 获取期刊期次信息详情 */
export function periodicalPeriodInfo(uuid) {
  return request({
    url: `/resource/periodical/period/info/${uuid}`,
    method: "get"
  });
}

/* 新增期刊期次信息 */
export function periodicalPeriodSave(data) {
  return request({
    url: `/resource/periodical/period/save`,
    method: "post",
    data
  });
}

/* 更新期刊期次信息 */
export function periodicalPeriodUpdate(data) {
  return request({
    url: `/resource/periodical/period/update`,
    method: "put",
    data
  });
}

/* 批量删除期刊期次 */
export function periodicalPeriodDelete(data) {
  return request({
    url: `/resource/periodical/period/delete`,
    method: "delete",
    data
  });
}
